import { useAuthStore } from './store/authStore';
import { LoginPage } from './pages/LoginPage';
import { WizardPage } from './pages/WizardPage';

export default function App() {
  const token = useAuthStore((s) => s.token);
  if (!token) return <LoginPage />;
  return <WizardPage />;
}
